<template>
  <aha-modal
    title="Woah, we're not quite ready yet!"
    @hide="hide()"
  >
    <div class="tab-content pb-4">
      <img src="@/assets/images/team/on-going-creat-new-team.png" />
      <p class="mt-4">
        Soon you'll be able to create multiple teams, but for now, you can only have one.
      </p>
      <aha-button class="float-right mb-2" @click="hide">
        Got it!
      </aha-button>
    </div>
  </aha-modal>
</template>
<script>

export default {
  data() {
    return {

    }
  },
  computed: {

  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style scoped>

</style>
